import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem('user_data');
    if (userData) {
      const full_name = JSON.parse(userData)["name"];
      if (full_name) {
        setUserName(full_name);
      }
    }
  }, []);

  const handleLogout = () => {
    // Clear both localStorage and sessionStorage
    localStorage.clear();
    sessionStorage.clear();
    
    // Navigate to auth page
    navigate('/auth');
  };

  return (
    <header className="bg-white shadow-sm h-16 flex items-center justify-between md:justify-end px-4 sticky top-0 z-30">
      <div className="md:hidden pl-3">
        <img src="/Assets/Images/logo.svg" alt="Project Sunflower Lanyard logo with a bright yellow half sunflower icon next to the text, on a purple background." className="h-12" />
      </div>
      <div className="flex items-center relative">
        {userName && (
          <span className="mr-2 text-gray-700 font-medium">
            {userName}
          </span>
        )}
        <button 
          className="p-2 hover:bg-gray-50 rounded-full"
          onClick={() => setShowTooltip(!showTooltip)}
        >
          <img src={"/Assets/Images/profileIcon.svg"} alt="Profile" className="w-6 h-6" />
        </button>
        
        {showTooltip && (
          <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-[10]">
            <button 
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;